import { SocketMessageTypes } from 'Modules/Socket'

export enum BgRequestType {
	CHECK_LIMIT = 'check_limit',
	CHECK_STATUS = 'check_status',
	LEAD_COMPLETE = 'lead_complete',
	POST_REQUEST = 'post_request',
	UPDATE_REQUEST = 'update_request',
	CALCULATE_COMMISSION = 'calculate_commission',
	GET_BANK_DATA = 'get_bank_data',
	SAVE_NEW_SEND_ADDRESS = 'save_new_send_address',
	CLONE_REQUEST = 'clone_request',
	POST_LIMIT_REQUEST = 'post_limit_request',
	UPDATE_LIMIT_REQUEST = 'update_limit_request',
	CURRENT_ELEMENTS = 'current_elements',
	SEND_TO_REWORK = 'send_to_rework',
	GET_GUARANTEE = 'get_guarantee',
	GET_CLIENT_LIMIT = 'get_client_limit',
	REQUEST_FIELDS_UPDATE = 'request_fields_update',
}

export const BgRequestTranslate = {
	[SocketMessageTypes.CHECK_LIMIT]: 'Чек-лимит',
	[SocketMessageTypes.CHECK_STATUS]: 'Чек-статус',
	[SocketMessageTypes.LEAD_COMPLETE]: 'Получено согласие',
	[SocketMessageTypes.POST_REQUEST]: 'Post-request',
	[SocketMessageTypes.UPDATE_REQUEST]: 'Update-request',
	[SocketMessageTypes.SAVE_NEW_SEND_ADDRESS]: 'Изменение данных по доставке',
}
